
/**
 * @description
 * 로드맵 상세 > 로드맵 소개
 */

import { ROADMAP_NAVIGATOR_ID } from '@/utils/enums.js';
import { mapGetters } from 'vuex';

import BoxButton from '@/components/common/btn/BoxButton.vue';

export default {
  name: 'CourseDescription',
  components: { BoxButton },
  data() {
    return {
      openDescription: false,
      descriptionSection: null,
      isOpenDescriptionScrollHeight: 0,
    };
  },
  computed: {
    ...mapGetters('course', ['description']),
    descriptionNavId: () => ROADMAP_NAVIGATOR_ID.DESCRIPTION,
    showMoreBtn: ({ descriptionSection }) =>
      descriptionSection?.getBoundingClientRect().height > 800,
  },
  mounted() {
    this.descriptionSection = document.querySelector('#description');
    if (this.descriptionSection?.getBoundingClientRect().height > 800) {
      this.descriptionSection.parentElement.style.maxHeight = '800px';
    }
  },
  methods: {
    onClickMoreBtn() {
      if (this.openDescription) {
        this.descriptionSection.parentElement.style.maxHeight = '800px';
        // 더보기를 닫을 때 열었던 높이로 맞춰줍니다 but 만약 현재 높이보다 낮은 곳일때만
        this.isOpenDescriptionScrollHeight >=
          document.documentElement.getBoundingClientRect().top &&
          document.documentElement.scrollTo({
            top: -this.isOpenDescriptionScrollHeight,
          });
        this.openDescription = false;
      } else {
        this.descriptionSection.parentElement.style.maxHeight = '';
        this.isOpenDescriptionScrollHeight =
          document.documentElement.getBoundingClientRect().top;
        this.openDescription = true;
      }
    },
  },
};
